import { render } from "./WalletHistory.vue?vue&type=template&id=0c1d576a"
import script from "./WalletHistory.vue?vue&type=script&lang=js"
export * from "./WalletHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__